import { isAboveViewport, isPartOfViewport } from "./helper";

export default function animateBarOnScroll() {
    const animatingDomEles = document.querySelectorAll("[data-mb-animate-bar]");
    // on init
    checkAnimationdomEles(animatingDomEles);

    if (animatingDomEles.length > 0) {
      document.addEventListener("scroll", (event) => {
        // on scroll
        if (getWidth() > 767) {
          checkAnimationdomEles(animatingDomEles);
        }
      });
    }
}

function getWidth() {
    if (self.innerWidth) {
      return self.innerWidth;
    }

    if (document.documentElement && document.documentElement.clientWidth) {
      return document.documentElement.clientWidth;
    }

    if (document.body) {
      return document.body.clientWidth;
    }
}

function checkAnimationdomEles(animatingDomEles) {
    for (let i = 0; i < animatingDomEles.length; i++) {
      const direction = animatingDomEles[i].dataset.mbAnimate;
      const innViewport = isPartOfViewport(animatingDomEles[i]) || isAboveViewport(animatingDomEles[i]);

      if (innViewport) {
        animatingDomEles[i].classList.add("in-viewport");
      }
    }
}
